<div class="profile-container">
  <div class="profile-content">
    <!-- Header -->
    <div class="profile-header">
      <button mat-icon-button (click)="onBack()" class="back-button">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <h1>Felhasználói Profil</h1>
    </div>

    <!-- Profil kártya -->
    <mat-card class="profile-card">
      <mat-card-header>
        <div mat-card-avatar class="profile-avatar">
          <mat-icon class="avatar-icon common-details-icon">{{ getUserIcon() }}</mat-icon>
        </div>
        <mat-card-title>{{ currentUser?.name || 'Felhasználó' }}</mat-card-title>
        <mat-card-subtitle>{{ currentUser?.jobNames?.join(', ') || 'Munkatárs' }}</mat-card-subtitle>
      </mat-card-header>

      <mat-card-content>
        <div class="profile-details">
          <!-- 2 oszlopos elrendezés -->
          <div class="profile-layout">
            <!-- Bal oldal - Alapadatok (75%) -->
            <div class="main-content">
              <div class="details-section">
                <h3>
                  <mat-icon>person</mat-icon>
                  Alapadatok
                </h3>
                <mat-divider></mat-divider>

                <div class="detail-row">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Teljes név</mat-label>
                    <input matInput [value]="currentUser?.name || ''" readonly>
                    <mat-icon matSuffix>badge</mat-icon>
                  </mat-form-field>
                </div>

                <div class="detail-row editable-field">
                  <!-- Szerkesztési mód -->
                  @if (isEditingUsername) {
                    <div class="edit-mode">
                      <mat-form-field appearance="outline" class="full-width editing">
                        <mat-label>Felhasználónév</mat-label>
                        <input matInput
                          [(ngModel)]="editableUsername"
                          [ngModelOptions]="{standalone: true}"
                          (keydown)="onUsernameKeydown($event)"
                          placeholder="Felhasználónév">
                      </mat-form-field>
                      <div class="edit-actions">
                        <button mat-icon-button (click)="saveUsernameEdit()" class="save-btn" matTooltip="Mentés">
                          <mat-icon>check</mat-icon>
                        </button>
                        <button mat-icon-button (click)="cancelUsernameEdit()" class="cancel-btn" matTooltip="Mégse">
                          <mat-icon>close</mat-icon>
                        </button>
                      </div>
                    </div>
                  }

                  <!-- Megjelenítési mód -->
                  @if (!isEditingUsername) {
                    <mat-form-field appearance="outline" class="full-width">
                      <mat-label>Felhasználónév</mat-label>
                      <input matInput
                        [value]="getDisplayUsername()"
                        readonly>
                      <div matSuffix class="suffix-icons">
                        <mat-icon class="edit-icon"
                          (click)="toggleUsernameEdit()"
                        matTooltip="Szerkesztés">edit</mat-icon>
                        <mat-icon>account_circle</mat-icon>
                      </div>
                    </mat-form-field>
                  }
                </div>

                <div class="detail-row">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>E-mail cím</mat-label>
                    <input matInput [value]="currentUser?.email || ''" readonly>
                    <mat-icon matSuffix>email</mat-icon>
                  </mat-form-field>
                </div>

                <div class="detail-row">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Munkakör</mat-label>
                    <input matInput [value]="currentUser?.jobNames?.join(', ') || ''" readonly>
                    <mat-icon matSuffix>work</mat-icon>
                  </mat-form-field>
                </div>
              </div>
            </div>

            <!-- Jobb oldal - Jogosultságok és Rendszer info (25%) -->
            <div class="sidebar-content">
              <!-- Jogosultságok -->
              <div class="details-section">
                <h3>
                  <mat-icon>security</mat-icon>
                  Jogosultságok
                </h3>
                <mat-divider></mat-divider>

                <div class="permissions-container">
                  <mat-chip-set class="permissions-chips">
                    <mat-chip disabled>
                      {{ currentUser?.jobNames?.join(', ')}}
                    </mat-chip>
                  </mat-chip-set>
                </div>
              </div>

              <!-- Rendszer információk -->
              <div class="details-section">
                <h3>
                  <mat-icon>info</mat-icon>
                  Információk
                </h3>
                <mat-divider></mat-divider>

                <div class="system-info">
                  <div class="info-item">
                    <mat-icon>schedule</mat-icon>
                    <span>Legutolsó aktivitás: {{ getFormattedLastActivity() }}</span>
                  </div>
                  <div class="info-item">
                    <mat-icon>verified_user</mat-icon>
                    <span>Létrehozva: {{ getFormattedCreatedDate() }}</span>
                  </div>

                  <div class="info-item">
                    <mat-icon>verified_user</mat-icon>
                    <span>Státusz: {{ getUserStatus() }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-card-content>

      <mat-card-actions>
        <button mat-stroked-button (click)="onChangePassword()">
          <mat-icon>lock</mat-icon>
          Jelszó változtatása
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
</div>
